import React from "react";
import atoms from "../../../atoms";
import moment from "moment";
import { InProcessDataProps, InProcessOrderProps } from "./interface";
import { convertToCommaFormat, getCountryDialCode, priceTagFormatter } from "../../../../constants/utils";
import ThreeDotsAction from "./component/action";

const { Search, Table, Pagination, Input } = atoms;

const Index = ({
    receiptData,
    setSearch,
    setLimitPerPage,
    setCurrentPage,
    currentPage,
    limit,
    handlePrintSharePdf,
    handleReadyOrder,
}: InProcessOrderProps) => {
    const columns = [
        {
            name: "Date",
            selector: (row: InProcessDataProps) =>
                moment(row?.createdAt).format("DD/MM/YYYY"),
        },
        {
            name: "Store Name",
            selector: (row: InProcessDataProps) => row?.store?.store_location || "",
            minWidth: "150px",
        },
        {
            name: "Order Id",
            selector: (row: InProcessDataProps) => row?.order_id_display,
        },
        {
            name: "Customer Name",
            selector: (row: InProcessDataProps) => row?.customer?.name || "-",
        },
        {
            name: "Mobile No.",
            selector: (row: InProcessDataProps) =>  `${getCountryDialCode()} ${row?.customer?.mobile}`,
        },
        {
            name: "Total Amount",
            selector: (row: InProcessDataProps) => priceTagFormatter(row?.total_amount) || "-",
        },
        {
            name: "Total Items",
            selector: (row: InProcessDataProps) => (
                <>
                    <div>
                        <p className="mb-1 ">Total Order : {row.total_order_items}</p>
                        <p className="mb-1 ">
                            Delivered : {row.total_delivered_order_items}
                        </p>
                        <p className="mb-1 ">Pending : {row.total_pending_order_items}</p>
                    </div>
                </>
            ),
            width: "150px",
        },
        {
            name: "Delivery Date",
            selector: (row: any) =>
                moment(row?.delivery_date).isValid()
                    ? moment(row?.delivery_date).format("DD/MM/YYYY")
                    : row?.delivery_date || "-",
            width: "150px",
            text: "center",
        },
        { name: "Action", selector: (row: any) => row?.action, center: true },
    ];

    return (
        <>
            <div className="row">
                <div className="col-md-6 mb-2">
                    <Search
                        className="search search-style w-100"
                        searchCallBack={(e: string) => setSearch(e)}
                    />
                </div>
                <div className="col-md-6 mb-2">
                </div>
            </div>
                <div>
                    <Table
                        columns={columns}
                        data={receiptData?.data?.map((item: any) => {
                            return {
                                ...item,
                                order_status: item?.store_pick_up ? (
                                    <div className="background-light-yellow border-product-radius custom-badge">
                                        <p className="color-yellow m-1 p-1">{"Store pickup"}</p>
                                    </div>
                                ) : (
                                    <div className="background-light-green border-product-radius custom-badge">
                                        <p className="color-green m-1 p-1">{"Home pickup"}</p>
                                    </div>
                                ),
                                action: (
                                    <ThreeDotsAction
                                        handlePrintSharePdf={handlePrintSharePdf}
                                        item={item}
                                        handleReadyOrder={handleReadyOrder}
                                    />
                                ),
                            };
                        })}
                    />
                </div>
                <div>
                    <Pagination
                        currentPage={currentPage}
                        totalPages={receiptData?.totalPages}
                        onChangePage={(page: number) => setCurrentPage(page)}
                        setLimit={(e: number) => {
                            setLimitPerPage(e);
                        }}
                        limit={limit}
                    />
                </div>
        </>
    );
};

export default Index;
